import { apiRequest } from '~/shared-kernel/infrastructure/http/api-client'
import type { PublicEventInformation } from '~/modules/public/purchase/domain/public-event-information'

export function getPublicEventInformation(publicSlug: string): Promise<PublicEventInformation> {
  return apiRequest<PublicEventInformation>('GET', '/public/events/{publicSlug}/information', { params: { path: { publicSlug } } })
}
